import { Box, Chip } from "@mui/material";
import { useTranslation } from "react-i18next";

import { Service } from "../../types/service.type";

const ProgramCardFooter = ({ service }: { service: Service }) => {
  const { t: tCurrency } = useTranslation("goService", { keyPrefix: "serviceCurrency" });
  const {
    paymentConfig: { amount, currency },
  } = service;

  return (
    <Box sx={styles.container}>
      <Chip label={`${tCurrency(currency)} ${amount / 100}`} sx={styles.programChip} />
    </Box>
  );
};

export default ProgramCardFooter;

const styles = {
  container: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    padding: "0 16px 16px",
    height: "54px",
  },
  programChip: {
    fontFamily: "Montserrat",
    color: "var(--White, #FFF)",
    fontSize: "18px",
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: "normal",
    height: "fit-content",
    padding: "4px 12px",
    background: "var(--Brand-600, #008B07)",
    "& .MuiChip-label": {
      padding: "0",
    },
  },
};
